<template>
  <div class="projects-tree-wrap" :class="{'projects-tree-wrap_empty': isEmpty}"
       :style="{ left: `${leftPosition}px` }"
       ref="myElement"
       :key="keyTrigger"
       draggable="false">
    <div class="projects-tree-wrap__line"
         :style="{ width: `${lineWidth}px` }">
    </div>
    <div class="hide-line-main"
         :style="{ width: `${lineWidth}px` }"></div>
    <ul class="projects-list">
      <node-tree :node="treeObjData"
                 @addNodeOnDragEmit="addNodeOnDragFunc($event)"
                 :dragFlag="randomString"
                 :level="0"
                 :lastId="lastId"
                 @lastChildWidth="lineWidth = $event"
                 :mother-node="motherProject"
                 :mother-project="motherProject"></node-tree>
    </ul>
  </div>
</template>

<script>
  import nodeTree from './nodeTree'
  import {dragNdrapProjects} from "../../../../mixins/dragNdrop/dragNdropProjects";
  import {loaderMixin} from "../../../../mixins/utils/loaderMixin";
  import {mapState} from "vuex";

  export default {
    props: {
      treeData: {
        type: Object,
        default: {
          name: 'Empty'
        }
      },
      motherProject: Object,
      dragEndFlag: Boolean
    },
    mixins: [dragNdrapProjects, loaderMixin],
    components: {
      nodeTree
    },
    data() {
      return {
        lineWidth: '',
        mainBlock: '',
        dataTree: {},
        dragFlag: false,
        randomString: '',
        lastId: 0,
        keyTrigger: 1,
        leftPosition: 0
      }
    },
    watch: {
      dopElemOnDragVuex(val) {
        if (val) {
          this.leftPositionFN()
        }
      },
      treeData() {
        let abc = "abcdefghijklmnopqrstuvwxyz";
        let rs = "";
        while (rs.length < 6) {
          rs += abc[Math.floor(Math.random() * abc.length)];
        }
        this.keyTrigger = rs
        this.lineWidth = -7
        this.lastId = this.treeData.items[this.treeData.items.length - 1].id
      },
      lineWidth() {
        this.lineWidth = 0
        if (!document.querySelector('.last-children') || document.querySelector('.last-children') === null) {
          this.lineWidth = -6
          return
        }
        this.mainBlock = document.querySelector('.projects-tree-wrap')
        this.lineWidth = this.mainBlock.clientWidth - document.querySelector('.last-children').clientWidth + 41
        if (this.treeData.items.length === 1) {
          this.lineWidth = 0
          document.querySelector('.projects-tree-wrap__line').style.borderRight = '0'
        } else {
          document.querySelector('.projects-tree-wrap__line').style.borderRight = '1px solid #6194AF'
        }
      },
      dragEndFlag() {
        if (this.dragEndFlag) {
          this.removeNodeOnDragStop()
        }
        this.lineWidth = -4
      },
      loader() {
        if (!this.loader) {
          this.lineWidth = -1
        }
      },
    },
    computed: {
      ...mapState({
        loader: state => state.popups.loader,
        dopElemOnDragVuex: state => state.projects.dopElemOnDrag,
      }),
      isEmpty() {
        return this.treeData.items.length <= 1
      },
      // вывод дерева
      // else изначальный
      // в if с показыванием скрытого блока
      treeObjData() {
        this.lastId = this.treeData.items[this.treeData.items.length - 1].id
        if (this.dragFlag) {
          this.dragFlag = false
          this.lineWidth = -5
          return this.dataTree
        } else {
          this.lineWidth = -5
          return this.treeObj
        }
      },
      // добавление скрытых блоков
      treeObj() {
        let arr = JSON.parse(JSON.stringify(this.treeData))
        let childArr = (items, id) => {
          let count = 0
          let place = 0
          let countElem = 0
          let arrLength = items.length
          for (let i = 0; i < arrLength; i++) {
            let obj = {place: place, index: count, id: 'asd' + id, name: 'TEST' + count, permission_level: 3, items: [], permissions: [], dopNode: true, show: true}
            items.splice(count, 0, obj)
            count += 2
            place += 1
          }
          items.push({place: place, index: count, id: 'asd' + id, name: 'TEST' + count, permission_level: 3, items: [], permissions: [], dopNode: true, show: true})
          items.forEach((item) => {
            if (item.sort_attribute || item.sort_attribute === null) {
              item['prevElem'] = countElem
              countElem += 2
              item['nextElem'] = countElem
            }
            if (item.items && item.items.length > 0) {
              childArr(item.items, item.id)
            }
          })
        }
        if (arr.items.length > 0) {
          childArr(arr.items, arr.id)
        }
        this.dopElemOnDrag = arr
        return arr
      }
    },
    methods: {
      leftPositionFN() {
        // для позициониролвания первого уровня когда там только один элемент
        if (this.treeObjData.items.length === 3 && (document.querySelector('.last-children') || document.querySelector('.last-children') !== null)) {
          let projectsListWidth = document.querySelector('.projects-list').clientWidth
          this.leftPosition = (projectsListWidth - 220) / 30 * 15
        }
      },
      // при отжатии мышки если отпустили в пустоте то сбрасывает все в начало
      removeNodeOnDragStop() {
        this.dragFlag = true
        let text = "";
        let possible = "abcdefghijklmnopqrstuvwxyz";

        for( let i=0; i < 5; i++ )
          text += possible.charAt(Math.floor(Math.random() * possible.length));
        this.randomString = text
        let arr = JSON.parse(JSON.stringify(this.treeData))
        this.dragFlag = false
        let childArr = (items, id) => {
          let count = 0
          let place = 0
          let countElem = 0
          let arrLength = items.length
          for (let i = 0; i < arrLength; i++) {
            let obj = {place: place, id: 'asd' + id, index: count, name: 'TEST' + count, permission_level: 3, items: [], permissions: [], dopNode: true, show: true}
            items.splice(count, 0, obj)
            count += 2
            place += 1
          }
          items.push({place: place, id: 'asd' + id, index: count, name: 'TEST' + count, permission_level: 3, items: [], permissions: [], dopNode: true, show: true})
          items.forEach((item) => {
            if (item.sort_attribute || item.sort_attribute === null) {
              item['prevElem'] = countElem
              countElem += 2
              item['nextElem'] = countElem
            }
            if (item.items && item.items.length > 0) {
              childArr(item.items, item.id)
            }
          })
        }
        if (arr.items.length > 0) {
          childArr(arr.items, arr.id)
        }
        this.$emit('changeFlag')
        this.dopElemOnDrag = arr
        this.dataTree = arr
        this.lineWidth = -3
      },
      // при наведении на невидимую область показывать нужный скрытый блок
      addNodeOnDragFunc(data) {
        this.dragFlag = true
        let arr = JSON.parse(JSON.stringify(this.treeObj))
        let childArr = (items, id) => {
          if (id === Number(data.parentId)) {
            items[Number(data.count)].show = false
          } else {
            items.forEach((item) => {
              if (item.items && item.items.length > 0) {
                childArr(item.items, item.id)
              }
            })
          }
        }
        if (arr.id === Number(data.parentId)) {
          arr.items[Number(data.count)].show = false
        }
        if (arr.items.length > 0) {
          childArr(arr.items, arr.id)
        }
        this.dopElemOnDrag = arr
        this.dataTree = arr
      }
    },

    mounted() {
      this.mainBlock = document.querySelector('.projects-tree-wrap')
    },
  }
</script>

<style lang="scss" scoped>
  $line: #6194AF;


  .projects-tree-wrap {
    position: relative;
    padding-top: 7px;
    margin: 0 auto;
    width: fit-content;


    .projects-tree-wrap__line {
      content: '';
      position: absolute;
      width: calc(100% - 181px);
      //width: calc(100% - 211px);
      height: 28px;
      left: 90px;
      top: 0;
      border-top: 1px solid $line;
      border-left: 1px solid $line;
      border-right: 1px solid $line;
      border-radius: 8px 8px 0 0;
      z-index: 4;
    }
  }

  .hide-line-main {
    position: absolute;
    top: 0;
    left: 90px;
    width: 100%;
    height: 10px;
    z-index: 3;

    &:after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 10px;
      height: 10px;
      background: #e9f0f4;
    }

    &:before {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      width: 10px;
      height: 10px;
      background: #e9f0f4;
    }
  }

  .projects-tree-wrap_empty {
    &::before {
      width: 1px;
      height: 30px;
      background: $line;
      border: none;
      left: 50%;
      bottom: 100%;
    }
  }


  .projects-list {
    display: flex;
    justify-content: center;
    margin-left: -20px;
    margin-right: -20px;
  }

  .project-tree-cont {
    width: fit-content;
    min-width: 100%;
    position: absolute;
    top: 22px;
    left: 30px;
    padding-right: 30px;
  }
</style>
